// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles-" + {"891":"40ba618f43bf4856b193","933":"9b1bed6c7cb8eb325b20"}[chunkId] + ".css";
};